"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractParam = exports.getStaticParams = exports.getDynamicParams = void 0;
var tslib_1 = require("tslib");
var FallbackMapper_1 = require("./FallbackMapper");
var _get = require("lodash/get");
exports.getDynamicParams = function (cmsElementRoot, context) {
    var dynamicParams = context.dynamicParams;
    return (cmsElementRoot.dynamicParams || []).reduce(function (accumulator, paramDetails) {
        var _a;
        var limit = paramDetails.limit
            ? parseInt(paramDetails.limit, 10)
            : null;
        var dynamicParamValueLength = dynamicParams[paramDetails.type]
            ? dynamicParams[paramDetails.type].length
            : 0;
        var dynamicParamValue = !dynamicParams[paramDetails.type] ||
            (limit && dynamicParamValueLength > limit)
            ? paramDetails.defaultValue
            : dynamicParams[paramDetails.type];
        return tslib_1.__assign(tslib_1.__assign({}, accumulator), (_a = {}, _a[paramDetails.name] = dynamicParamValue, _a));
    }, {});
};
exports.getStaticParams = function (cmsElementRoot, context) {
    var paramsArray = _get(cmsElementRoot, getDataByStrategy(cmsElementRoot, context, ['params']));
    return (paramsArray || []).reduce(function (accumulator, paramKeyValue) {
        var _a;
        var cleanedKey = paramKeyValue.key.replace(/\{|\}/g, '');
        return tslib_1.__assign(tslib_1.__assign({}, accumulator), (_a = {}, _a[cleanedKey] = paramKeyValue.string, _a));
    }, {});
};
exports.extractParam = function (cmsElementRoot, context) {
    var names = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        names[_i - 2] = arguments[_i];
    }
    return _get(cmsElementRoot, getDataByStrategy(cmsElementRoot, context, names));
};
var getDataByStrategy = function (cmsElementRoot, context, paramPath) {
    var strategies = FallbackMapper_1.getParamExtractingStrategies(context, paramPath);
    return strategies.find(function (strategy) {
        var extracted = _get(cmsElementRoot, strategy);
        return extracted !== undefined && extracted !== ''; // extracted === 0 should be considered as valid and truthy.
    });
};
//# sourceMappingURL=ParamExtractor.js.map